import moment from 'moment';
import { Text } from '@shared/components/Text';
import { Colors } from '@shared/styles';

interface ChatDateStampProps {
  date: string;
  fontSize?: number;
  opacity?: 1 | 0;
  color?: string;
}

export function ChatDateStamp({
  date,
  fontSize = 10,
  opacity = 1,
  color = Colors.v2.gray50,
}: ChatDateStampProps) {
  // Relative dates for Today and Yesterday, with time
  // Absolute dates for older dates: Thu Apr 1, 4:01 PM
  // Absolute dates for dates in previous years: Thu Apr 1, 2024, 4:01 PM

  const formattedDate = moment(date).calendar(null, {
    sameDay: '[Today], LT',
    lastDay: '[Yesterday], LT',
    lastWeek: 'ddd MMM D, LT',
    sameElse: function (now) {
      return moment(date).year() === moment(now).year() ? 'ddd MMM D, LT' : 'ddd MMM D, YYYY, LT';
    },
  });

  return (
    <Text style={{ fontSize, opacity, letterSpacing: -0.1, lineHeight: 'normal' }} color={color}>
      {formattedDate}
    </Text>
  );
}
